import { defineNuxtPlugin } from '#app'
import ARFeatureLocker from '@/directives/ARFeatureMask'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ARFeatureLocker)
})
